import type { AtkInfoType } from '@/types/fight'
import type { ElementType } from '@/types/relic'
import { relicIcon } from '@/views/item/data'

export function fightExplain(atkInfoList: AtkInfoType[], element: ElementType) {
  return atkInfoList
    .map((item) => {
      const { monsterTrigger, trigger, damage, unHit } = item
      const monsterTriggerText = monsterTrigger.length ? `${monsterTrigger.map((item) => `<i>${item}</i>`).join(' ')}，` : ''
      const triggerText = trigger.length ? `${trigger.map((item) => `<b>${item}</b>`).join(' ')}，` : ''
      if (unHit) {
        return `${monsterTriggerText}${triggerText}攻击未命中${damage < 0 ? `，怪物回复 <span class="grow">${Math.abs(damage)}</span> 血量` : ''}`
      }
      if (damage < 0) {
        return `${monsterTriggerText}${triggerText}怪物回复 <span class="grow">${Math.abs(damage)}</span> 血量`
      }
      return `${monsterTriggerText}${triggerText}造成 <span class="hp">${relicIcon[element] || ''}${damage}</span> 点伤害`
    })
    .join('<br />')
}
